import { Grid, Box, Divider, Typography } from '@mui/material';
import { format } from 'date-fns';
import { useState } from 'react';
import { IOneReviewProps } from './ReviewRating.helper';
import { oneReviewBoxStyles, oneReviewDividerStyles, oneReviewRatingBoxMargin, oneReviewReadMoreStyles, oneReviewSourceMargins, oneReviewMobileMargin } from './ReviewRating.styles';
import ReviewStars from './ReviewStars';
const MAX_PREVIEW_LENGTH = 150;
const getShortText = (text: string) => text.length >= MAX_PREVIEW_LENGTH ? `${text.slice(0, MAX_PREVIEW_LENGTH).trim()}.... ` : text;
export default function OneReview({
  review,
  showFullReview,
  dataTestId,
  mobileWidth = false
}: IOneReviewProps) {
  const [full, setFull] = useState(false);
  const fullText = review?.comments ?? '';
  const isLong = fullText.length > MAX_PREVIEW_LENGTH;
  const textVariant = mobileWidth ? 'bodyMediumBook' : 'bodyLargeBook';
  return <>
			<Grid sx={oneReviewMobileMargin} data-testid={dataTestId} data-sentry-element="Grid" data-sentry-source-file="OneReview.tsx">
				<Box sx={oneReviewBoxStyles} data-sentry-element="Box" data-sentry-source-file="OneReview.tsx">
					<Box sx={oneReviewRatingBoxMargin} data-sentry-element="Box" data-sentry-source-file="OneReview.tsx">
						<ReviewStars rating={review.rating ?? 0} data-sentry-element="ReviewStars" data-sentry-source-file="OneReview.tsx" />
					</Box>
					<Typography variant={textVariant} color="text.secondary" data-sentry-element="Typography" data-sentry-source-file="OneReview.tsx">
						{showFullReview || full ? fullText : <>
								{getShortText(fullText)}
								{isLong && <Typography variant={textVariant} color="text.link" sx={oneReviewReadMoreStyles} onClick={() => setFull(true)}>
										Read more
									</Typography>}
							</>}
					</Typography>
					{
        // facebook or yelp or etc
        review.source && <Typography variant="bodyMediumBook" color="text.secondary" sx={oneReviewSourceMargins}>
								Posted on {review.source}
							</Typography>}
					{
        // review posted date
        review.reviewTimestamp && <Typography variant="bodyMediumBook" color="text.secondary">
								{format(new Date(review.reviewTimestamp), 'MM/dd/yyyy')}
							</Typography>}
				</Box>
			</Grid>
			{!showFullReview && <Divider sx={oneReviewDividerStyles} />}
		</>;
}